<template>
    <Box title="我的审批" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <van-tabs swipeable background="rgba(0,0,0,0)" line-width="20px" @click='tabsClick' v-model="tabsIndex" ref="tabs">
            <van-tab :title="'待我审批('+Total+')'">
                <div class="tagsBox">
                    <LoadingFooter :finished="finished" @scroll="IsSee=false" @load="onLoad" v-model="loading">
                        <div class="commonItems" v-for="item in List"  @click="pageSkip(item,true)">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <p class="ellipsis">{{item.SQDH}}</p>
                                    <div>
                                        <div>
                                            <p>申请人:</p>
                                            <p>申请时间:</p>
                                            <p>资产编号:</p>
                                            <p>资产名称:</p>
                                            <p>规格型号:</p>
                                        </div>
                                        <div class="WidthPx">
                                            <p class="ellipsis">{{item.SQR}}</p>
                                            <p class="ellipsis">{{item.SQRQ}}</p>
                                            <p class="ellipsis">{{item.SBBH}}</p>
                                            <p>{{item.SBMC}}</p>
                                            <p class="ellipsis">{{item.SBXH}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>去审批</div>
                                </div>
                            </div>
                            <div>
                                <span>审核类型</span>
                                <span>{{item.TYPE}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
            <van-tab :title="'我已审批('+TotalSecond+')'">
                <div class="tagsBox">
                    <LoadingFooter :finished="finishedSecond" @load="onLoadSecond" @scroll="IsSee=false" v-model="loadingSecond">
                        <div class="commonItems" v-for="item in ListSecond" @click="pageSkip(item)">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <p class="ellipsis">{{item.SQDH}}</p>
                                    <div class="background"></div>
                                    <div>
                                        <div>
                                            <p>申请人:</p>
                                            <p>申请时间:</p>
                                            <p>资产编号:</p>
                                            <p>资产名称:</p>
                                            <p>规格型号:</p>
                                        </div>
                                        <div class="WidthPx">
                                            <p class="ellipsis">{{item.SQR}}</p>
                                            <p class="ellipsis">{{item.SQRQ}}</p>
                                            <p class="ellipsis">{{item.SBBH}}</p>
                                            <p>{{item.SBMC}}</p>
                                            <p class="ellipsis">{{item.SBXH}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>详情</div>
                                </div>
                            </div>
                            <div>
                                <span>审核类型</span>
                                <span>{{item.TYPE}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
        </van-tabs>
        <transition name="fade">
        <div class="menu" v-if="IsSee">
            <Field title="申请人" placeholder="请选择" type='manufacturer' name='personnel' :text='search.SQRMC'
            @manuconfirm="search.SQR=arguments[0].b" />

            <Field title="资产编号" placeholder="请输入" type='input' :text='search.SBBH' @onMessage="value=>search.SBBH=value" />

            <Field title="审核类型" placeholder="请选择" :text='ReviewTheTypesFacturer' type='popup'
            :data="['全部审核','转科审核','报废审核','外调审核','维修审核','申购审核']"
                @confirm="ReviewTheTypesFacturer=arguments[0]" />

            <Field title="开始日期" placeholder="请选择" :text='search.StartDate' type="calendar" @onMessage="value=>search.StartDate=value" />
            <Field title="开始日期" placeholder="请选择" :text='search.EndDate' type="calendar" @onMessage="value=>search.EndDate=value" />
            <div class="search" @click="serach">查询</div>
        </div>
        </transition>
    </Box>

</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import {
        Tab,
        Tabs
    } from 'vant'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    import Field from '../../components/field/field'
    export default {
        name: 'DispatchList',
        components: {
            Box,
            LoadingFooter,
            Field,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        data() {
            return {
                //我已审批   页面参数
                finishedSecond:false,
                loadingSecond:true,
                ListSecond:[],
                pageSecond:10,
                TotalSecond:0,

                hiddenInput: false,
                tabsIndex: 0,
                search: {
                    StartDate: null,
                    EndDate: null,
                    SBBH:null,
                    SPLX:'0',
                    SQR: null,
                },
                List:[],
                finished:false,
                loading:true,
                touchStartY: 0,
                page: 10,
                Total:0,
                IsSee:false,
                ReviewTheTypesFacturer:null,
                TYPE: [{
                        id: '0',
                        name: '全部审核'
                    }, {
                        id: '4',
                        name: '转科审核'
                    }, {
                        id: '3',
                        name: '报废审核'
                    },
                    {
                        id: '5',
                        name: '外调审核'
                    }, {
                        id: '2',
                        name: '维修审核'
                    }, {
                        id: "'1','6'",
                        name: '申购审核'
                    }],
            }
        },
        activated() {
           this.loadDataDefault();
        },
        methods: {
            onLoad() {
                if(!this.loading && !this.finished){
                   this.page+=10;
                   this.loadDataDefault();
               }
            },
            serach(){
               this.IsSee=false;
               this.tabsIndex===0?
               this.loadDataDefault():this.loadDataDefaultSecond()
            },
            loadDataDefault() {
               this.$post('api/Audit/GetApplyList',{
                    Type:true,
                    PageIndex:1,
                    PageSize:this.page,
                    GKHM:this.$UserInfo.UserId,
                    STORE:this.$UserInfo.StoreCode,
                    SPLX:this.search.SPLX,
                    SBBH:this.search.SBBH,
                    SQR:this.search.SQR,
                    StartDate:this.search.StartDate,
                    EndDate:this.search.EndDate
               }).then(result=>{
                   this.List=result.Model;
                   this.Total=result.Total;
                   if(this.Total<=this.page){
                      this.loading = false;
                      this.finished = true;
                   }else this.loading=false;
               })
            },pageSkip(item,ExistsButton){//页面跳转
               let Url='SubscribeApply'
               if(item.SPLX==='2')
               {
                    Url='Examine';
                    item.OrderNo=item.SQDH;
                    item.EquId=item.SBBH;
               }
               this.$router.push({name:Url,params:{item,ExistsButton}});
            },tabsClick(){//选项卡切换
                this.IsSee=false;
                if(this.tabsIndex===0){//未审核
                     this.loadDataDefault();
                }else {
                    this.loadDataDefaultSecond();
                }
            },onLoadSecond(){//已审核下拉事件
                if(!this.finishedSecond&&!this.loadingSecond){
                    this.pageSecond+=10;
                    this.loadDataDefaultSecond();
                }
            },loadDataDefaultSecond(){//已审核查询列表
                this.$post('api/Audit/GetApplyList',{
                     Type:false,
                     PageIndex:1,
                     PageSize:this.pageSecond,
                     GKHM:this.$UserInfo.UserId,
                     STORE:this.$UserInfo.StoreCode,
                     SPLX:this.search.SPLX,
                     SBBH:this.search.SBBH,
                     SQR:this.search.SQR,
                     StartDate:this.search.StartDate,
                     EndDate:this.search.EndDate
                }).then(result=>{
                    this.ListSecond=result.Model;
                    this.TotalSecond=result.Total;
                    if(this.TotalSecond<=this.pageSecond){
                       this.loadingSecond = false;
                       this.finishedSecond = true;
                    }else this.loadingSecond=false;
                })
            }
        },
        watch: {
            $route(to, from) {

            },ReviewTheTypesFacturer(value) {
                this.search.SPLX = this.TYPE.find(x => x.name === value).id;
            }
        }
    }
</script>

<style scoped lang="scss">
    .lineLength{
        position:relative;
        top:20px;
        left:250px;
        color:#FFFFFF;
        z-index: 20;
        font-size: 30px;

        display:inline-flex;
    }
    .tagsBox {
        margin-top: 120px;
    }

    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        top: 28vw;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 80px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    // .listLength {
    //     font-size: 29px;
    //     color: #4a4a4a;
    //     margin-bottom: 18px;
    //     margin-left: 30px;
    //     top: 700px;

    //     span {
    //         margin-left: 20px;
    //         color: $THEME-COLOR;
    //         font-weight: bold;
    //     }
    // }

    // .commonItems:nth-child(3) {
    //     margin-top: 680px;
    // }

    .searchEdit {
        position: absolute;
        width: 98px;
        height: 60px;
        border-radius: 30px;
        background: #037A72;
        text-align: center;
        right: 20px;
        top: 20px;
        z-index: 20;
        img {
            width: 38px;
            margin-top: 11px;
        }
    }
    .searchBox {
        height: 86px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 20;
        background: $THEME-COLOR;

        img {
            width: 30px;
            height: 30px;
            position: absolute;
            left: 50px;
        }


        span {
            font-size: 26px;
            color: #fff;
            margin-left: 20px;
        }
    }
    .WidthPx{
        p:nth-child(4){
            width: 28vw !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .background{
        background-color: #ff9e48;
    }
</style>



// WEBPACK FOOTER //
// src/page/examineList/examineList.vue